<template>
    <div class="public-layout">
        <modal-loader />
        <div class="login-page">
            <div class="header-container">
                <LanguageSelector class="selector-mobile" />
                <div class="logo-desktop">
                    <img :src="require('@/assets/images/intratone/logo.svg')" />
                </div>
                <i
                    class="fas fa-bars burger-menu"
                    color="unset"
                    :class="displayMenu && 'animate'"
                    @click="displayMenu = !displayMenu"
                ></i>
                <LanguageSelector
                    class="selector-desktop color-background-selector"
                    alignement="right"
                />
            </div>
            <div class="logo-mobile">
                <img :src="require('@/assets/images/intratone/logo.svg')" />
            </div>

            <div class="content-container">
                <router-view></router-view>
            </div>
        </div>
        <ul class="navigation" :class="displayMenu && 'animate'">
            <li
                v-for="item in computedLinks"
                :key="item.title"
                @click="displayMenu = false"
            >
                <a :href="item.link" target="_blank">
                    <img :src="item.icon" />
                    <span>{{ item.title }}</span>
                </a>
            </li>
            <li>
                <router-link to="/support" @click="displayMenu = false">
                    <img :src="require('@/assets/images/icons/grid.svg')" />
                    <span>{{ $t("publicHome.support") }}</span>
                </router-link>
            </li>
        </ul>
        <div class="image-container">
            <div class="image-wrapper">
                <img
                    class="image-residence"
                    :src="require('@/assets/images/buildings/city-large.png')"
                    alt="residence"
                    width="680"
                    height="680"
                />
            </div>
        </div>
        <div class="reload" v-if="displayReload">
            <div>
                {{ $t("alerts.version.new_version") }}
            </div>
            <div class="reload-page" @click="reload">
                <i class="fas fa-sync-alt"></i>
                {{ $t("alerts.version.reload") }}
            </div>
        </div>
    </div>
</template>

<script>
import LanguageSelector from "@/components/LanguageSelector.vue"
import redirect from "@/mixins/redirection.js"
import BasicButton from "@/components/basic/BasicButton.vue"
import ModalLoader from "@/components/Modal/ModalLoader"
import navigation from "@/mixins/navigation"

import { getEnvironment } from "@/helpers/getEnvironment.js"
import { getTermsOfUsesURL } from "@/services/intratone/miscellaneous.js"

export default {
    name: "PublicLayout",
    mixins: [redirect, navigation],
    components: {
        LanguageSelector,
        ModalLoader,
    },
    data() {
        return {
            displayMenu: false,
            displayReload:
                window.location.href.search("reload=true") > 0 &&
                window.location.href.search("manuel=true") < 0,
            linksFr: [
                {
                    title: this.$t("publicHome.2gInfos"),
                    link: this.get2gInfos(),
                    icon: require("@/assets/images/icons/antenna.svg"),
                },
            ],
        }
    },
    computed: {
        lang() {
            let lang = window.location.pathname.replace(
                new RegExp("/", "g"),
                "",
            )
            return lang
        },
        computedLinks() {
            if (this.lang === "fr") {
                return [
                    ...this.links.slice(0, 3),
                    ...this.linksFr,
                    ...this.links.slice(3),
                ]
            }
            return this.links
        },
        links() {
            return [
                {
                    title: this.$t("publicHome.residenceTransfer"),
                    link: this.getTransfert(),
                    icon: require("@/assets/images/icons/residence.svg"),
                },
                {
                    title: this.$t("publicHome.manuals"),
                    link: this.getNotices(),
                    icon: require("@/assets/images/icons/badges.svg"),
                },
                {
                    title: this.$t("publicHome.returnCoupon"),
                    link: this.getBonSAV(),
                    icon: require("@/assets/images/icons/loading.svg"),
                },
                {
                    title: this.$t("publicHome.programmerSetup"),
                    link: "https://home.intratone.info/v2/?&r=1#/setup",
                    icon: require("@/assets/images/icons/parking.svg"),
                },
                {
                    title: this.$t("publicHome.terms"),
                    link: this.getConditions,
                    icon: require("@/assets/images/icons/message.svg"),
                },
            ]
        },
    },
    methods: {
        reload() {
            window.history.pushState(
                {},
                "Intratone - Site de gestion",
                `${window.location.href}&manuel=true`,
            )
            this.totalClear()
        },

        async callGetTermsOfUsesUrl() {
            await getTermsOfUsesURL({ lng: this.findLang() }).then(
                (response) => {
                    this.$store.commit(
                        "account/setTermsOfUsesURL",
                        response.data.url,
                    )
                },
            )
        },
    },
    beforeMount() {
        this.callGetTermsOfUsesUrl()
    },
    mounted() {
        this.$store.commit("auth/setParam", getEnvironment())
    },
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/global.scss";
@import "@/assets/scss/variables/fontSize.scss";

.public-layout {
    display: flex;
}

.reload {
    position: absolute;
    background-color: $blue-lighter;
    color: $white;
    width: 100vw;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    align-items: center;
    gap: 20px;
    top: calc(100vh - 50px);
    font-weight: 500;
    line-height: 1.08;
    letter-spacing: 0.05em;
    font-size: 14px;
    font-family: "Avenir Roman";
    .reload-page {
        cursor: pointer;
        color: white;
        background-color: $orange;
        padding: 10px;
        border-radius: 10px;
    }
}

.color-background-selector :deep(.bd-display-value) {
    background-color: transparent !important;
}

.login-page {
    height: 100svh;
    background-color: $white;
    display: flex;
    flex-direction: column;
    align-content: center;
    align-items: center;
    overflow-y: auto;
    padding: 1em;
    max-width: 600px;
    width: 100%;

    @media all and (min-width: 1024px) {
        padding: 3em;
    }

    .header-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }

    .logo-desktop,
    .logo-mobile {
        img {
            width: 150px;
            height: 30px;
            pointer-events: none;
        }
    }

    .logo-desktop {
        display: none;

        @media all and (min-width: 1024px) {
            display: block;
        }
    }

    .logo-mobile {
        padding-top: 20px;

        @media all and (min-width: 1024px) {
            display: none;
        }
    }

    .content-container {
        max-width: 100%;
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
}

@media all and (min-width: 1024px) {
    .selector-desktop {
        display: block;
    }

    .burger-menu,
    .selector-mobile {
        display: none;
    }
    .navigation li {
        margin-bottom: 10px;
    }
    .navigation li a {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .navigation li:last-child {
        margin-bottom: 0;
        max-width: 800px;
    }
    .navigation span {
        font-family: $font_avenir_heavy;
        font-size: $small;
        line-height: 13px;
    }
    .navigation a {
        border-radius: 0 30px 30px 0;
        color: $white;
        font-weight: 500;
        line-height: 1.08;
        text-align: center;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 10px 10px;
        font-size: $normal;
        text-decoration: none;
        -webkit-transition: 0.1s ease-in all;
        transition: 0.1s ease-in all;
    }
    .navigation a:hover {
        background-color: $blue-lighter;
    }
    .navigation a img {
        margin-bottom: 10px;
    }
    .navigation {
        transition: 0.25s ease-in all;
        -webkit-transition: 0.25s ease-in all;
        list-style: none;
        -webkit-transform: rotateY(0);
        transform: rotateY(0);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        align-content: center;
        padding: unset;
        margin: unset;
        li {
            width: 200px;
            a {
                width: 150px;
                height: 100px;
                font-size: $small;
                background-color: $blue-light;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -ms-flex-direction: column;
                flex-direction: column;
                span {
                    width: 130px;
                    color: $white;
                }
            }
            a:hover {
                width: 175px;
                padding-left: 25px;
            }
        }
    }

    .image-container {
        display: flex;
        flex-grow: 1;

        .image-wrapper {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .image-residence {
                pointer-events: none;
                width: 85%;
                max-width: 550px;
                height: auto;

                @media all and (max-width: 1024px) {
                    display: none;
                }
            }
        }
    }

    .login-page {
        border-radius: 0 50px 50px 0;
    }
}
@media all and (max-height: 864px) {
    .navigation {
        li {
            a {
                height: 90px;
            }
        }
    }
}
@media all and (max-width: 1024px) {
    .selector-desktop {
        display: none;
    }

    .burger-menu,
    .selector-mobile {
        display: block;
    }
    .image-residence {
        display: none;
    }
    .public-layout {
        width: 100%;
    }
    .login-page {
        width: 100%;
        max-width: unset;
        min-width: 100%;
        border-radius: unset;
    }
    .login-page {
        border-radius: unset;
    }
    .burger-menu {
        font-size: $veryBig;
        color: $blue-neutral;
        z-index: 20;
    }
    .burger-menu.animate {
        color: $white;
    }
    .navigation {
        display: none;
    }
    .navigation.animate::-webkit-scrollbar {
        display: none; /* for Chrome, Safari, and Opera */
    }
    .navigation.animate {
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        align-content: center;
        width: 100vw;
        background-color: $blue-light;
        z-index: 10;
        animation-name: glissement;
        animation-duration: 0.1s;
        animation-fill-mode: forwards;
        padding-top: 50px;
        height: 100vh;
        -ms-overflow-style: none; /* for Internet Explorer, Edge */
        scrollbar-width: none; /* for Firefox */
        overflow: scroll;
        li {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            align-content: center;
            margin-bottom: 20px;
            margin-top: 20px;
            a {
                color: $white;
                font-weight: 500;
                line-height: 1.08;
                text-align: center;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                font-size: $normal;
                text-decoration: none;
                -webkit-transition: 0.1s ease-in all;
                transition: 0.1s ease-in all;
            }
            a:hover {
                background-color: $blue-lighter;
                padding-left: 20px;
            }
            a img {
                margin-bottom: 10px;
                width: 7vw;
                height: 7vw;
            }
            a span {
                margin-left: 20px;
                font-size: $big;
            }
        }
        li:last-child {
            margin-bottom: 0;
        }
    }
}
@keyframes glissement {
    from {
        margin-left: 100%;
    }
    to {
        margin-left: -100%;
        display: block;
    }
}
</style>
